import { css } from '@/styled-system/css';

export const petList = css({
  listStyle: 'none',
  margin: '0',
  padding: '0',
});

export const petRow = css({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 'tight',
  paddingBlock: 'tighter',
  '&:first-child': {
    paddingBlockStart: 'default',
    borderTopWidth: 'default',
    borderTopStyle: 'solid',
    borderTopColor: 'border.neutral',
  },
  '&:last-child': {
    paddingBlockEnd: 'default',
  },
});

export const petRowBody = css({
  display: 'flex',
  flexDirection: 'column',
  flex: '1',
  minWidth: '0',
});

export const petRowHeading = css({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'baseline',
  columnGap: 'tighter',
});

// Centres the first line on the DuoColorIcon (its recipe's icon.xl) with the row top-aligned, so Read more never moves the icon.
export const petHeadingText = css.raw({ paddingBlockStart: 'calc(({sizes.icon.xl} - 1lh) / 2)' });

export const petNotes = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'tighter',
  marginBlockStart: 'tighter',
  overflowWrap: 'break-word',
});

export const petIcon = css.raw({ borderRadius: 'shape.ellipse' });
